import { memo } from "react";
import { Box } from "@mui/material";

function ReservationTruckIcon({ ...other }) {
  return (
    <Box {...other}>
      <svg
        width="35"
        height="28"
        viewBox="0 0 35 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2452_22466)">
          <path
            d="M17.4 4.0625C17.785 4.0625 18.1 4.37188 18.1 4.75V17.125C18.1 17.5031 17.785 17.8125 17.4 17.8125H16H12.64C11.9137 16.5793 10.5575 15.75 9 15.75C7.4425 15.75 6.08625 16.5793 5.36 17.8125H4.8C4.415 17.8125 4.1 17.5031 4.1 17.125V4.75C4.1 4.37188 4.415 4.0625 4.8 4.0625H17.4ZM18.8 19.875C18.8 22.1523 20.6812 24 23 24C25.3188 24 27.2 22.1523 27.2 19.875H28.95C29.5319 19.875 30 19.4152 30 18.8438C30 18.2723 29.5319 17.8125 28.95 17.8125H28.6V12.5402C28.6 11.9 28.3419 11.2898 27.8825 10.8387L23.8006 6.82969C23.3412 6.37852 22.72 6.125 22.0681 6.125H20.2V4.75C20.2 3.2332 18.9444 2 17.4 2H4.8C3.25563 2 2 3.2332 2 4.75V17.125C2 18.6418 3.25563 19.875 4.8 19.875C4.8 22.1523 6.68125 24 9 24C11.3187 24 13.2 22.1523 13.2 19.875H16H17.4H18.45H18.8ZM26.3994 12.2953C26.4037 12.2996 26.4125 12.3082 26.4169 12.3125H20.2V8.1875H22.0681C22.16 8.1875 22.2519 8.22188 22.3175 8.28633L26.3994 12.2953ZM6.9 19.875C6.9 19.328 7.12125 18.8034 7.51508 18.4166C7.9089 18.0298 8.44305 17.8125 9 17.8125C9.55695 17.8125 10.0911 18.0298 10.4849 18.4166C10.8788 18.8034 11.1 19.328 11.1 19.875C11.1 20.422 10.8788 20.9466 10.4849 21.3334C10.0911 21.7202 9.55695 21.9375 9 21.9375C8.44305 21.9375 7.9089 21.7202 7.51508 21.3334C7.12125 20.9466 6.9 20.422 6.9 19.875ZM23 17.8125C23.557 17.8125 24.0911 18.0298 24.4849 18.4166C24.8787 18.8034 25.1 19.328 25.1 19.875C25.1 20.422 24.8787 20.9466 24.4849 21.3334C24.0911 21.7202 23.557 21.9375 23 21.9375C22.443 21.9375 21.9089 21.7202 21.5151 21.3334C21.1212 20.9466 20.9 20.422 20.9 19.875C20.9 19.328 21.1212 18.8034 21.5151 18.4166C21.9089 18.0298 22.443 17.8125 23 17.8125Z"
            fill="#1D5AB9"
          />
        </g>
        <defs>
          <clipPath id="clip0_2452_22466">
            <rect
              width="28"
              height="22"
              fill="white"
              transform="translate(2 2)"
            />
          </clipPath>
        </defs>
      </svg>
    </Box>
  );
}

export default memo(ReservationTruckIcon);
